import { EmptyData } from '../../../core/models/empty-data';
import { UrlConfigContainer } from '../../../core/url-config';
import { AjaxDataServiceService } from '../../../core/ajax-data-service.service';
import { SubscriberModel } from '../models/subscriber-model';
import { PagingWrapper } from '../../../core/models/paging-wrapper';
import { Observable } from 'rxjs';
import { SubscriberFilterModel } from '../models/subscriber-filter-model';
import { PagingFilter } from '../../../shared/models/paging-filter.model';
import { Injectable } from '@angular/core';
import { UrlConfigService } from '@hrra/core';

@Injectable()
export class SubscriberService {
  public listSubscriber(
    filter: PagingFilter<SubscriberFilterModel>
  ): Observable<PagingWrapper<SubscriberModel>> {
    return this.ajax.postDataPaging(
      this.urlService.urlConfig.api.data.subscribers.list,
      filter.toObject(),
      SubscriberModel
    );
  }

  public deleteSubscriber(subscriberId: number) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.subscribers.delete,
      { subscriberId: subscriberId },
      EmptyData
    );
  }

  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}
}
